exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding[data-v-6b9eb28e]{padding-left:10%}.position-no[data-v-6b9eb28e]{position:absolute;top:0;right:0;z-index:-1}.expandableContainer[data-v-6b9eb28e]{border-style:solid;border-color:#e6e6e6;border-radius:15px;border-width:2px}td[data-v-6b9eb28e],th[data-v-6b9eb28e]{width:295px;max-width:295px;min-width:295px}[data-v-6b9eb28e] .v-datatable.v-table>tbody{max-height:7vh;min-height:7vh}.v-btn--floating.v-btn--small .v-icon[data-v-6b9eb28e]{width:40px!important}", ""]);

// exports
